// Third party
import React from 'react';

// Components
import ComparisonTopBarBaseMenuItem from './ComparisonTopBarBaseMenuItem';
import { ContactPastille } from '../../../../components/misc';

// Utils
import { formatMessage } from '../../../../../utils/i18n';
import ComparisonContact from '@/types/comparison-contact';

type Props = {
  onClick?: () => void;
  contact: ComparisonContact;
  contactName: string;
};

const ComparisonTopBarContactMenuItem = ({ onClick, contact, contactName }: Props) => {
  let comparisonContact = contact;

  if (!contact.fname && !contact.lname && contact.fullName) {
    const nameWords = contactName.split(' ');
    comparisonContact = {
      ...contact,
      fname: nameWords[0] || '',
      lname: nameWords[1] || '',
    };
  }

  return (
    <ComparisonTopBarBaseMenuItem
      onClick={onClick}
      label={formatMessage('Comparison.Contact')}
      content={
        <>
          <ContactPastille contact={comparisonContact} />
          <span className="contact-name" data-private data-dd-privacy="mask">
            {contactName}
          </span>
        </>
      }
    />
  );
};

export default ComparisonTopBarContactMenuItem;
